'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.ConditionalDataTable = void 0;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _RenderTable = require('../RenderTable'),
    _ShowHide = require('../ShowHide'),
    _ShowHide2 = _interopRequireDefault(_ShowHide);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var ConditionalDataTable = exports.ConditionalDataTable = function (a) {
  var b = a.show,
      c = a.colDefns,
      d = a.rowData,
      e = a.udButtons,
      f = a.showHeader;
  return _react2.default.createElement(_ShowHide2.default, {
    show: b
  }, _react2.default.createElement(_RenderTable.RenderTableData, {
    colDefns: c,
    rowData: d,
    showHeader: f,
    udButtons: e
  }));
};

ConditionalDataTable.propTypes = {
  show: _propTypes2.default.bool,
  colDefns: _propTypes2.default.arrayOf(_propTypes2.default.array),
  rowData: _propTypes2.default.arrayOf(_propTypes2.default.object),

  /**
  A React Component that returns the Update & Delete Buttons
  */
  udButtons: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  showHeader: _propTypes2.default.bool
}, ConditionalDataTable.defaultProps = {
  show: !1,
  showHeader: !0,
  udButtons: function a() {},
  colDefns: [],
  rowData: []
}, exports.default = _react2.default.memo(ConditionalDataTable);